import { useNavigate } from "react-router-dom";
import { AppHeader } from "../../components/AppHeader";
import { AppFooter } from "../../components/AppFooter";
import { usePageTitle } from "../../hooks/usePageTitle";

export function NotFoundPage() {
  usePageTitle("페이지를 찾을 수 없음");
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "var(--bg-primary)" }}>
      <AppHeader />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
        <div style={{ fontSize: 72, marginBottom: 16 }}>{"🗺️"}</div>
        <h1 style={{ fontSize: 48, fontWeight: 900, color: "var(--lt-gold)", margin: "0 0 8px" }}>404</h1>
        <p style={{ fontSize: 18, color: "var(--text-primary)", fontWeight: 600, margin: "0 0 8px" }}>
          페이지를 찾을 수 없습니다
        </p>
        <p style={{ fontSize: 14, color: "var(--text-muted)", margin: "0 0 40px", textAlign: "center" }}>
          요청하신 페이지가 존재하지 않거나 이동되었습니다.
        </p>
        <div style={{ display: "flex", gap: 12 }}>
          <button
            onClick={() => navigate("/")}
            style={{ padding: "12px 24px", borderRadius: 12, border: "none", background: "var(--lt-gold)", color: "#0F172A", fontSize: 15, fontWeight: 700, cursor: "pointer" }}
          >
            홈으로
          </button>
          <button
            onClick={() => navigate("/listings")}
            style={{ padding: "12px 24px", borderRadius: 12, border: "1px solid var(--border-medium)", background: "transparent", color: "var(--text-secondary)", fontSize: 15, fontWeight: 600, cursor: "pointer" }}
          >
            매물 보기
          </button>
        </div>
      </div>
      <AppFooter />
    </div>
  );
}
